import { PanelContainer, NodePanelProps } from "../../lib/panel/panel-container";
import { WalletNotificationNodeData } from "../node-types";
import { PanelWalletNotification } from "./panel-wallet-notification";

export function WalletNotificationActionNodePanel(props: NodePanelProps<WalletNotificationNodeData>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelWalletNotification />
    </PanelContainer>
  );
}
